import React, { Component } from 'react'
import styles from './style.module.less'
import store from './store'
import { observer } from 'mobx-react'
import ModalIf from '@common/ModalIf'
import mainStore from '@components/Main/store'
import { getMoney } from '@hlj/hlj-utils'

@observer
export default class extends Component {
  componentDidMount() {
    store.getTagList()
  }

  render() {
    const {
      group,
      group_count,
      recommend,
      recommend_count,
      hotTop,
      hotTop_count,
      cheap,
      cheap_count,
      addImgshow,
      proModal,
      gradeModal,
      onCancelPro,
      onCancelGrade
    } = store

    const {
      merchantInfo: { is_special_merchant }
    } = mainStore

    return (
      <div className={styles.box}>
        {(is_special_merchant == 1 || is_special_merchant == 2) && (
          <p style={{ marginBottom: 10, fontSize: 14 }}>
            <i className={styles.attention}>i</i>
            {is_special_merchant == 1 && (
              <span>您的设置和修改将同步至所有的店铺，子店铺无法修改</span>
            )}
            {is_special_merchant == 2 && (
              <span>
                您无法修改当前设置，系统将默认认为您同步主门店的相关设置
              </span>
            )}
          </p>
        )}

        <p className={styles.title}>
          <span>团购套餐</span>
          <a href="#/localMerchant/marketingTools/hotTagImg">
            <img src="http://qnm.hunliji.com/o_1ale32qgh1f991dkn75l9ug1n0u7.png" />
          </a>
          <small>剩余{group_count}个</small>
        </p>

        <ul>
          {group.map(({ id, title, actual_price, cover_path }) => (
            <li key={id}>
              <img
                src={
                  cover_path
                    ? cover_path + '?imageView2/1/w/278/h/174/format/webp'
                    : ''
                }
              />
              <div className={styles.detail}>
                <div className={styles.txt}>
                  <p>{title}</p>
                  <p>{getMoney(actual_price)}</p>
                </div>
                <span onClick={store.delTag(id, 4)}>删除</span>
              </div>
            </li>
          ))}
          {(addImgshow || group_count > 0) && (
            <li className={styles.addImg} onClick={store.checkMerchant(4)}>
              <img src="http://qnm.hunliji.com/o_1b3e17nee82nf6211q21ld5192i7.png" />
            </li>
          )}
        </ul>

        <p className={styles.title}>
          <span>人气推荐</span>
          <a href="#/localMerchant/marketingTools/hotTagImg">
            <img src="http://qnm.hunliji.com/o_1ale32qgh1f991dkn75l9ug1n0u7.png" />
          </a>
          <small>剩余{recommend_count}个</small>
        </p>

        <ul>
          {recommend.map(({ id, title, actual_price, cover_path }) => (
            <li key={id}>
              <img
                src={
                  cover_path
                    ? cover_path + '?imageView2/1/w/278/h/174/format/webp'
                    : ''
                }
              />
              <div className={styles.detail}>
                <div className={styles.txt}>
                  <p>{title}</p>
                  <p>{getMoney(actual_price)}</p>
                </div>
                <span onClick={store.delTag(id, 1)}>删除</span>
              </div>
            </li>
          ))}
          {(addImgshow || recommend_count > 0) && (
            <li className={styles.addImg} onClick={store.checkMerchant(1)}>
              <img src="http://qnm.hunliji.com/o_1b3e17nee82nf6211q21ld5192i7.png" />
            </li>
          )}
        </ul>

        <p className={styles.title}>
          <span>本季热卖</span>
          <a href="#/localMerchant/marketingTools/hotTagImg">
            <img src="http://qnm.hunliji.com/o_1ale32qgh1f991dkn75l9ug1n0u7.png" />
          </a>
          <small>剩余{hotTop_count}个</small>
        </p>

        <ul>
          {hotTop.map(({ id, title, actual_price, cover_path }) => (
            <li key={id}>
              <img
                src={
                  cover_path
                    ? cover_path + '?imageView2/1/w/278/h/174/format/webp'
                    : ''
                }
              />
              <div className={styles.detail}>
                <div className={styles.txt}>
                  <p>{title}</p>
                  <p>{getMoney(actual_price)}</p>
                </div>
                <span onClick={store.delTag(id, 2)}>删除</span>
              </div>
            </li>
          ))}
          {(addImgshow || hotTop_count > 0) && (
            <li className={styles.addImg} onClick={store.checkMerchant(2)}>
              <img src="http://qnm.hunliji.com/o_1b3e17nee82nf6211q21ld5192i7.png" />
            </li>
          )}
        </ul>

        <p className={styles.title}>
          <span>超值特价</span>
          <a href="#/localMerchant/marketingTools/hotTagImg">
            <img src="http://qnm.hunliji.com/o_1ale32qgh1f991dkn75l9ug1n0u7.png" />
          </a>
          <small>剩余{cheap_count}个</small>
        </p>

        <ul>
          {cheap.map(({ id, title, actual_price, cover_path }) => (
            <li key={id}>
              <img
                src={
                  cover_path
                    ? cover_path + '?imageView2/1/w/278/h/174/format/webp'
                    : ''
                }
              />
              <div className={styles.detail}>
                <div className={styles.txt}>
                  <p>{title}</p>
                  <p>{getMoney(actual_price)}</p>
                </div>
                <span onClick={store.delTag(id, 3)}>删除</span>
              </div>
            </li>
          ))}
          {(addImgshow || cheap_count > 0) && (
            <li className={styles.addImg} onClick={store.checkMerchant(3)}>
              <img src="http://qnm.hunliji.com/o_1b3e17nee82nf6211q21ld5192i7.png" />
            </li>
          )}
        </ul>

        <ModalIf
          type={proModal.type}
          isShow={proModal.isShow}
          content={proModal.content}
          btn1={proModal.btn1}
          btn2={proModal.btn2}
          hrefVal={proModal.hrefVal}
          onClick={onCancelPro}
        />

        <ModalIf
          type={gradeModal.type}
          isShow={gradeModal.isShow}
          content={gradeModal.content}
          btn1={gradeModal.btn1}
          btn2={gradeModal.btn2}
          hrefVal={gradeModal.hrefVal}
          onClick={onCancelGrade}
        />
      </div>
    )
  }
}
